<template>
  <v-tooltip  bottom   :nudge-top="10" :disabled="!isDisable && !isLocked">
    <template v-slot:activator="{ on }">
      <div v-on="on" class="fill-height" :class="isDisable ? '' : 'card-badge'">
        <v-card @click="handleSwitch" :disabled="isDisable" color='black' :style="{cursor:isDisable ? 'default' : 'pointer'}" outlined class="pa-1 rounded-lg fill-height ">
          <div class="d-flex items-center flex-column justify-center">
            <div class="d-flex flex-row items-start mx-1 justify-space-between">
              <v-chip outlined color="primary" class="pa-2 ma-1">
                <v-icon color="primary">{{ icon }}</v-icon>
              </v-chip>
              <!-- Sem acesso o card continua clicavel (abre a previa borrada),
                   mas nao pode virar o app padrao. -->
              <v-switch
                :disabled="isDisable || isLocked"
                inset
                color="orange"
                :input-value="value"
                @change="handleSwitch"
                hide-details
                class="mt-1"
                @click.stop
              ></v-switch>
            </div>
            <div style="width:100%; overflow:hidden" class="d-flex flex-column items-start justify-start mx-1 pa-1">
              <span class="label-bold">{{ title }}</span>
              <span class="label-sub">{{ subtitle }}</span>
            </div>
          </div>
        </v-card>
      </div>
    </template>
    <span>{{ isLocked ? $t('extras.noAccess') : $t('extras.comingSoon') }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: ["title", 'changeSwitch', "value", "icon", "subtitle", "isDisable", "isLocked"],
  methods:{
    handleSwitch()
    {
      if (this.isDisable) return
      this.changeSwitch(this.title)
    }
  },
  computed:{
    handleColorDisabled()
    {
      return this.isDisable ? '#202020':'black';
    }
  }
};
</script>
<style scoped>
.label-bold {
  /* Tracking em `em`, não `rem`: em rem ele é absoluto e não acompanha a fonte,
     então subir o título de 20 para 24px deixou o espaçamento parado em 1,6px
     (6,7% do corpo, ~9x o de um .text-h5 do Vuetify) e o texto esticado.
     0.02em mantém um respiro da marca e escala junto se o corpo mudar.
     BaseBadge e BaseAssetClass ficam lado a lado na /home e compartilham esta
     tipografia de propósito - mudar um exige mudar o outro. */
  /* Teto em 24px (o tamanho escolhido para desktop) e piso em 17px. Passou a
     importar quando os cards viraram 2-up ja no sm: a 600px cada coluna tem
     ~276px e o titulo fixo em 24px comia a linha inteira. */
  font-size: clamp(17px, 1.1vw + 9px, 24px) !important;
  letter-spacing: 0.02em;
  font-weight: 700 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-badge{
  border: 1px solid transparent;
  border-radius: 8px;
}
.card-badge:hover{
  border-color:#febd0b6b;
}

.label-sub {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  font-size: 15px;
}

/* Abaixo do md a coluna fica estreita demais para uma linha so, e cortar o
   subtitulo perde a informacao inteira - "Dados de Mercado, Calendario..."
   viraria "Dados de Mer...". Duas linhas com reticencia na segunda. */
@media screen and (max-width: 959px) {
  .label-sub {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

::v-deep .v-input{
  margin:0;
}

</style>
